import React, {useEffect} from 'react';
import View from './view';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../../redux';
import {holderProfileSelector, profileSettingsSelector} from '../../../redux/selectors/profile';
import {useAccountLinker} from '../../../shared/hooks/useAccountLinkerHook/useAccountLinker';
import {getProfileApplications} from '../../../redux/actions/profile';

export const DesktopProfile: React.FC = () => {
  const holderProfile = useSelector(holderProfileSelector());
  const profileSettings = useSelector(profileSettingsSelector());
  const dispatch = useAppDispatch();

  const {loadLinkedAccountsInfo} = useAccountLinker();

  useEffect(() => {
    loadLinkedAccountsInfo();
    dispatch(getProfileApplications());
  }, []);

  return <View holderProfile={holderProfile} profileSettings={profileSettings} />;
};
